import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { commonRoutesConstants, routeConstants } from "services/keyConstants";
import * as url from "./urlHelper";
import CommonYearList from "components/reusables/CommonYearList";

const CorrectiveActionTable = Loadable(
  lazy(() => import("../CorrectiveActionTable"))
);
const AddCustomerComplaint = Loadable(
  lazy(() => import("../AddCustomerComplaint"))
);
const ComplaintTables = Loadable(lazy(() => import("../ComplaintTables")));
const ComplaintRegister = Loadable(lazy(() => import("../ComplaintRegister")));

const CustomerView = Loadable(lazy(() => import("../CustomerView")));

const CorrectiveActionCC = Loadable(
  lazy(() => import("../CorrectiveActionCC"))
);

const CCRoutes = [
  {
    path: routeConstants.CUSTOMER_COMPLAINTS,
    children: [
      { path: "add-complaint", element: <AddCustomerComplaint /> },
      { path: "customerComplaint", element: <CustomerView /> },
      { path: "complaint-table", element: <ComplaintTables /> },
      { path: "complaint-register", element: <ComplaintRegister /> },
      { path: "complaint-capa", element: <CorrectiveActionTable /> },
      { path: "capa-cc/:id", element: <CorrectiveActionCC /> },
      // {
      //   path: commonRoutesConstants.YEAR_LIST,
      //   element: (
      //     <CommonYearList
      //       uri={url.GET_BY_YEAR}
      //       isCreate={true}
      //       createRoute={{
      //         path: `/${routeConstants.CUSTOMER_COMPLAINTS}/add-complaint`,
      //       }}
      //       title="Customer Complaint"
      //       navigateToFolder={`/${routeConstants.CUSTOMER_COMPLAINTS}/list/`}
      //     />
      //   ),
      // },
    ],
  },
];

export default CCRoutes;
